import gql from 'graphql-tag'

export const MUTATION_ADMIN_LOGIN = gql`
  mutation AdminLoginWithGoogle($sourceLoginUrl: String = "", $token: String!) {
    adminLoginWithGoogle(sourceLoginUrl: $sourceLoginUrl, token: $token) {
      emailConfirmed
      deviceConfirmationToken
      deviceConfirmed
      multiUser
    }
  }
`

export const QUERY_USER_ACCOUNTS = gql`
  query UserAccounts($cursor: String, $limit: Float, $search: String) {
    userAccounts(cursor: $cursor, limit: $limit, search: $search) {
      cursor
      accounts {
        dbName
        id
        idExternal
        name
        statusAccount {
          adjusting
          churn
          deploying
          deprecated
          done
          impossibleSupport
          temporaryChurn
          test
        }
        flags {
          industry {
            has_mercapromo
            only_mercapromo
          }
        }
      }
    }
  }
`

export const MUTATION_SELECT_USER_ACCOUNT = gql`
  mutation SelectUserAccount($accountId: String!) {
    selectUserAccount(accountId: $accountId) {
      message
    }
  }
`

export const QUERY_CHECK_AVAILABLE_EMAIL = gql`
  query EmailIsAvailable($email: String!) {
    emailIsAvailable(email: $email) {
      result
    }
  }
`

export const QUERY_VALIDATE_EMAIL_CONFIRMATION_TOKEN = gql`
  query EmailConfirmationToken($token: String!) {
    emailConfirmationToken(token: $token) {
      email
    }
  }
`

export const MUTATION_REQUEST_EMAIL_CONFIRMATION = gql`
  mutation SendUserEmailConfirmation($email: String!, $password: String!) {
    sendUserEmailConfirmation(email: $email, password: $password) {
      message
    }
  }
`

export const MUTATION_CONFIRM_EMAIL_AND_CHANGE_PASSWORD = gql`
  mutation ConfirmUserEmailAndChangePassword($token: String!, $oldPassword: String!, $newPassword: String!) {
    confirmUserEmailAndChangePassword(token: $token, oldPassword: $oldPassword, newPassword: $newPassword) {
      message
    }
  }
`

export const QUERY_CONFIRM_PASSWORD = gql`
  query PasswordIsValid($password: String!, $token: String!) {
    passwordIsValid(password: $password, token: $token) {
      result
    }
  }
`

export const MUTATION_CONFIRM_DEVICE_CODE = gql`
  mutation ConfirmUserDevice($confirmationToken: String!, $saveDevice: Boolean!, $verificationCode: String!) {
    confirmUserDevice(confirmationToken: $confirmationToken, saveDevice: $saveDevice, verificationCode: $verificationCode) {
      message
      multiUser
    }
  }
`
export const MUTATION_RESEND_CONFIRM_CODE = gql`
  mutation ResendUserDeviceConfirmation($deviceConfirmationToken: String!, $phoneNumber: String, $senderType: SenderTypeEnum) {
    resendUserDeviceConfirmation(deviceConfirmationToken: $deviceConfirmationToken, phoneNumber: $phoneNumber, senderType: $senderType) {
      deviceConfirmationToken
    }
  }
`

export const MUTATION_SINGLE_LOGIN = gql`
  mutation Login($login: String!, $password: String!, $source: String) {
    login: loginSession(login: $login, password: $password, source: $source) {
      emailConfirmed
      deviceConfirmationToken
      deviceConfirmed
      multiUser
      hiddenPhone
      twoFactorToken
      phoneConfirmed
      phoneToken
    }
  }
`

export const MUTATION_LOGIN_SESSION_TWO_FACTOR = gql`
  mutation LoginSessionTwoFactor($code: String!, $token: String!) {
    loginSessionTwoFactor(code: $code, token: $token) {
      multiUser
    }
  }
`

export const MUTATION_LOGIN_SESSION_PHONE_VALIDATION = gql`
  mutation LoginSessionPhoneValidation($code: String!, $token: String!) {
    loginSessionPhoneValidation(code: $code, token: $token) {
      multiUser
      twoFactorToken
      deviceConfirmationToken
    }
  }
`

export const MUTATION_RESEND_TWO_FACTOR_CODE = gql`
  mutation ResendTwoFactorCode($token: String!, $senderType: SenderTypeEnum) {
    resendTwoFactorCode(token: $token, senderType: $senderType) {
      message
    }
  }
`

export const MUTATION_SEND_PHONE_VALIDATION = gql`
  mutation SendPhoneValidation($token: String!, $phone: String!) {
    sendPhoneValidation(token: $token, phone: $phone) {
      message
    }
  }
`

export const MUTATION_RESEND_PHONE_VALIDATION = gql`
  mutation ResendPhoneValidation($token: String!) {
    resendPhoneValidation(token: $token) {
      message
    }
  }
`

export const QUERY_AUTH_CODE = gql`
  query Token($source: String, $target: String, $redirectUrl: String) {
    token(source: $source, target: $target, redirectUrl: $redirectUrl) {
      authCode
      authTarget
    }
  }
`

export const QUERY_ME = gql`
  query Me {
    me: meUser {
      multiAccount
    }
  }
`

export const QUERY_ME_MERCAFACIL_ADMIN = gql`
  query MeMercafacilAdmin {
    me: meUser {
      mercafacilAdmin
    }
  }
`

export const MUTATION_LOGOUT = gql`
  mutation Logout {
    logout: logoutSession {
      message
    }
  }
`

export const MUTATION_VALIDATE_USER_BY_EMAIL = gql`
  mutation ValidateUserByEmail($email: String!) {
    validateUserByEmail(email: $email) {
      phoneConfirmed
      hasPhone
      hiddenPhone
      passwordRecoveryToken
    }
  }
`

export const MUTATION_VALIDATE_PASSWORD_CONFIRMATION_TOKEN = gql`
  mutation RecoveryPasswordConfirmationToken($confirmationToken: String!, $verificationCode: String!) {
    recoveryPasswordConfirmationToken(confirmationToken: $confirmationToken, verificationCode: $verificationCode) {
      token
    }
  }
`

export const MUTATION_CHANGE_PASSWORD_BY_EMAIL = gql`
  mutation ChangePasswordByEmail($newPassword: String!, $token: String!) {
    changePasswordByEmail(newPassword: $newPassword, token: $token) {
      message
    }
  }
`

export const MUTATION_VALIDATE_USER_BY_PHONE = gql`
  mutation ValidateUserByPhone($phone: String!, $token: String!, $resend: Boolean!) {
    validateUserByPhone(phone: $phone, token: $token, resend: $resend) {
      passwordRecoveryToken
    }
  }
`
